import { SlipOfferStatus } from '@bpos/v1/over-ask';
import { generateGuid } from '@frontend/sports/common/core/utils/string';
import { createReducer, on } from '@ngrx/store';

import { OverAskFlowState } from '../../model/over-ask/over-ask';
import { SingleSlipType } from '../bet-generation/slip-type';
import { BetslipOverAskActions } from './actions';
import { OverAskCounterOfferUpdates } from './services/over-ask-counter-offer-updates.service';
import { defaultOverAskState } from './state';

export const overAskReducer = createReducer(
    defaultOverAskState,
    on(BetslipOverAskActions.startFlow, (state, action) => {
        // When we start the process,
        return {
            flowState: OverAskFlowState.Pending,
            offerId: action.offerId,
            parentRequestId: action.parentRequestId,
            bets: action.bets,
            reviewState: {
                remainingSeconds: 0,
                offerChanged: false,
            },
            error: action.overAskOfferError,
            requestId: generateGuid(), // We are going to generate the place request id in the beginning so to prevent race problems if accepted offer comes from getStatus or push
            isofferModified: false,
        };
    }),
    on(BetslipOverAskActions.setOverAskOfferId, (state, action) => {
        return {
            ...state,
            offerId: action.offerId,
        };
    }),
    on(BetslipOverAskActions.finishFlow, (state) => {
        return defaultOverAskState;
    }),
    on(BetslipOverAskActions.traderHasCounterOffer, (state, action) => {
        return {
            ...state,
            flowState: OverAskFlowState.Review,
            bets: OverAskCounterOfferUpdates.updateBetsWithChanges(state.bets, action.betSlipOffers),
            decisionSource: action.decisionSource,
            isofferModified: action.betSlipOffers.every((o) => o.status === SlipOfferStatus.Modified),
        };
    }),
    on(BetslipOverAskActions.traderAcceptedOffer, (state, action) => {
        return {
            ...state,
            bets: OverAskCounterOfferUpdates.updateBetsWithChanges(state.bets, action.betSlipOffers),
            isofferModified: action.betSlipOffers.every((o) => o.status === SlipOfferStatus.Modified),
            decisionSource: action.decisionSource,
        };
    }),
    on(BetslipOverAskActions.removeBet, (state, action) => {
        return {
            ...state,
            bets: state.bets.map((b) => {
                if (b.type instanceof SingleSlipType && b.picks[0].pick.id.isEqual(action.pickId)) {
                    return { ...b, isRemoved: true };
                }

                return b;
            }),
        };
    }),
    on(BetslipOverAskActions.undoRemoveBet, (state, action) => {
        return {
            ...state,
            bets: state.bets.map((b) => {
                if (b.type instanceof SingleSlipType && b.picks[0].pick.id.isEqual(action.pickId)) {
                    return { ...b, isRemoved: false };
                }

                return b;
            }),
        };
    }),
    on(BetslipOverAskActions.toggleRemoveBet, (state, action) => {
        return {
            ...state,
            bets: state.bets.map((b) => {
                if (b.type instanceof SingleSlipType && b.picks[0].pick.id.isEqual(action.pickId)) {
                    return { ...b, isRemoved: !b.isRemoved };
                }

                return b;
            }),
        };
    }),
    on(BetslipOverAskActions.changePickStatus, (state, action) => {
        return {
            ...state,
            bets: state.bets.map((b) => {
                return {
                    ...b,
                    picks: b.picks.map((p) => {
                        if (p.pick.id.isEqual(action.pickId)) {
                            return {
                                ...p,
                                oddsState: action.state,
                            };
                        }

                        return p;
                    }),
                };
            }),
        };
    }),
    on(BetslipOverAskActions.acceptOfferTimeoutRemainingTime, (state, action) => {
        return {
            ...state,
            reviewState: {
                ...state.reviewState,
                remainingSeconds: action.seconds,
            },
        };
    }),
    on(BetslipOverAskActions.bettingOfferChanged, (state, action) => {
        return {
            ...state,
            reviewState: {
                ...state.reviewState,
                offerChanged: action.hasChanges,
            },
        };
    }),
    on(BetslipOverAskActions.permanentRemoveBet, (state, action) => {
        return {
            ...state,
            bets: state.bets.filter((b) => !(b.type instanceof SingleSlipType && b.picks[0].pick.id.isEqual(action.pickId))),
        };
    }),
);
